import './src/styles/global.scss';

import { GatsbyBrowser } from 'gatsby';
import RootLayout from './src/templates/root-layout';

export const wrapPageElement: GatsbyBrowser<
  GatsbyTypes.MainPageQuery,
  {
    language: string;
    titleImagePath: string;
    buttonImagePath: string;
    pathname: string;
    game: string;
    subGame: string;
    backgroundColor?: string;
  }
>['wrapPageElement'] = ({ element, props }) => {
  return <RootLayout {...props}>{element}</RootLayout>;
};
